import { StatusChipText } from '@labrav/react-components'

import { OfferStatus, offerStatusMap } from '../../modules/privateOffer/reducer'
import type { CloudMarketplace } from '../../types/index'
import { getKeyFromValue } from './getKeyFromValue'

export const getStatusAndLabelForPrivateOffer = (
  status: OfferStatus,
  cloud?: CloudMarketplace
) => {
  const statusLabel = getKeyFromValue(status)(offerStatusMap) || ''
  switch (status) {
    case OfferStatus.PRIVATE_OFFER_CREATION_IN_PROGRESS:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: statusLabel,
      }
    case OfferStatus.PRIVATE_OFFER_EMAIL_SENT:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: statusLabel,
      }
    case OfferStatus.PRIVATE_OFFER_VIEWED:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: statusLabel,
      }
    case OfferStatus.PRIVATE_OFFER_ACCEPTED:
      return {
        textColor: StatusChipText.GREEN,
        label: statusLabel,
      }
    case OfferStatus.PRIVATE_OFFER_EXPIRED:
      return {
        textColor: StatusChipText.GRAY,
        label: statusLabel,
      }
    case OfferStatus.PRIVATE_OFFER_FAILED:
      return {
        textColor: StatusChipText.RED,
        label: statusLabel,
      }
    case OfferStatus.PRIVATE_OFFER_RESTRCITED:
      return {
        textColor: StatusChipText.RED,
        label: cloud === 'AZURE' ? 'Deactivated' : statusLabel,
      }
    case OfferStatus.PRIVATE_OFFER_IN_DRAFT:
      return {
        textColor: StatusChipText.GRAY,
        label: statusLabel,
      }
    case OfferStatus.PRIVATE_OFFER_RESTRICTION_IN_PROGRESS:
      return {
        textColor: StatusChipText.RED,
        label: cloud === 'AZURE' ? 'Deactivation in progress' : statusLabel,
      }
    case OfferStatus.OFFER_TERMS_ACCEPTED_BUYER:
      return {
        textColor: StatusChipText.YELLOW,
        label: statusLabel,
      }
    case OfferStatus.OFFER_PURCHASE_COMPLETE:
      return {
        textColor: StatusChipText.GRAY,
        label: statusLabel,
      }
    // The remaining Microsoft aliases share string values with the
    // PRIVATE_OFFER_* cases above, so they only ever hit this fallback.
    default:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: statusLabel,
      }
  }
}
